import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { MenuItems } from './../../modules/menu-items/menu-items';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import { AuthService } from './../../services/auth/auth.service';
import { SocketService } from './../../services/socket/socket-service';
import { Globals } from './../../services/globals';
import { environment } from './../../../environments/environment';
import { NotificationI } from '../../models/notification.interface';

declare var MediaRecorder: any;

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  providers:[SocketService],
  animations: [
    trigger('notificationBottom', [
      state('an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('an-animate',
        style({
          overflow: 'visible',
          height: AUTO_STYLE,
        })
      ),
      transition('an-off <=> an-animate', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('slideInOut', [
      state('in', style({
        width: '420px',
        // transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        width: '0',
        // transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('mobileHeaderNavRight', [
      state('nav-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('nav-on',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('nav-off <=> nav-on', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({opacity: 0}),
        animate('400ms ease-in-out', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({transform: 'translate(0)'}),
        animate('400ms ease-in-out', style({opacity: 0}))
      ])
    ]),
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateY(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateY(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateY(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateY(100%)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class AdminComponent implements OnInit, OnDestroy, AfterViewInit {
  public animateSidebar: string;
  public navType: string;
  public themeLayout: string;
  public verticalPlacement: string;
  public verticalLayout: string;
  public pcodedDeviceType: string;
  public verticalNavType: string;
  public verticalEffect: string;
  public vnavigationView: string;
  public freamType: string;
  public sidebarImg: string;
  public sidebarImgType: string;
  public layoutType: string;

  public headerTheme: string;
  public pcodedHeaderPosition: string;

  public liveNotification: string;
  public liveNotificationClass: string;

  public profileNotification: string;
  public profileNotificationClass: string;

  public chatSlideInOut: string;
  public innerChatSlideInOut: string;

  public searchWidth: number;
  public searchWidthString: string;

  public navRight: string;
  public windowWidth: number;
  public chatTopPosition: string;

  public toggleOn: boolean;
  public toggleIcon: string;
  public navBarTheme: string;
  public activeItemTheme: string;
  public pcodedSidebarPosition: string;

  public headerFixedTop: string;

  public menuTitleTheme: string;
  public dropDownIcon: string;
  public subItemIcon: string;

  public configOpenRightBar: string;
  public displayBoxLayout: string;
  public isVerticalLayoutChecked: boolean;
  public isSidebarChecked: boolean;
  public isHeaderChecked: boolean;
  public headerFixedMargin: string;
  public sidebarFixedHeight: string;
  public sidebarFixedNavHeight: string;
  public itemBorderStyle: string;
  public subItemBorder: boolean;
  public itemBorder: boolean;

  public isCollapsedSideBar: string;
  public psDisabled: string;
  public perfectDisable: string;

  public config: any;
  public searchInterval: any;

  private username:string = "";
  private profilePicURL:string = "";
  private logoURL:string = "";
  isReady:boolean = false;

  scroll = (): void => {
    const scrollPosition = window.pageYOffset;
    if (scrollPosition > 50) {
      if (this.isSidebarChecked === true) {
        this.pcodedSidebarPosition = 'fixed';
      }
      if (this.pcodedDeviceType === 'desktop') {
        this.headerFixedTop = '0';
      }
      this.sidebarFixedNavHeight = '100%';
    } else {
      if (this.pcodedDeviceType === 'desktop') {
        this.headerFixedTop = 'auto';
      }
      this.pcodedSidebarPosition = 'absolute';
      this.sidebarFixedNavHeight = '';
    }
  }

  //voice chat
  localAudio;
  remoteAudio;
  remoteAudioTime;
  localStream;
  remoteStream;
  rtcPeerConnection;
  iceServers = {'iceServers': [{'urls': 'stun:stun.services.mozilla.com'},{'urls': 'stun:stun.l.google.com:19302'}]};
  streamConstraints = {audio:true, video:false};
  connectedUser;

  onCall: boolean = false;
  callUserName: String = "";
  callUserId: String = "";
  callStatus: String = "";

  callTimer: any;

  baseUrl = environment.serviceURL;
  chatUsers: any = [];
  chatLoading: boolean = false;
  selectedChatUser: any;
  conversations: any = [];

  mediaRecorder: any;
  audioChunks: any = [];
  actionBtn: string = "";
  recording: boolean = false;
  chatMessage: string = "";

  public notifications: NotificationI[] = [];

  public newNotificationCount:number = 0;

  public baseURL = environment.serviceURL + '/companies/';
  public endPoint = '/download/logo';


  constructor(public menuItems: MenuItems, private authService: AuthService, private router: Router, private socketService: SocketService) {
    this.animateSidebar = '';
    this.navType = 'st2';
    this.themeLayout = 'vertical';
    this.verticalPlacement = 'left';
    this.verticalLayout = 'wide';
    this.pcodedDeviceType = 'desktop';
    this.verticalNavType = 'expanded';
    this.verticalEffect = 'shrink';
    this.vnavigationView = 'view1';
    this.freamType = 'theme1';
    this.sidebarImg = 'false';
    this.sidebarImgType = 'img1';
    this.layoutType = 'light'; // light(default) dark(dark)

    this.headerTheme = 'theme1'; // theme1(default)
    this.pcodedHeaderPosition = 'fixed';

    this.headerFixedTop = 'auto';

    this.liveNotification = 'an-off';
    this.profileNotification = 'an-off';

    this.chatSlideInOut = 'out';
    this.innerChatSlideInOut = 'out';

    this.searchWidth = 0;

    this.navRight = 'nav-on';

    this.toggleOn = true;
    this.toggleIcon = 'icon-toggle-right';
    this.navBarTheme = 'themelight1'; // themelight1(default) theme1(dark)
    this.activeItemTheme = 'theme1';
    this.pcodedSidebarPosition = 'fixed';
    this.menuTitleTheme = 'theme1'; // theme1(default) theme10(dark)
    this.dropDownIcon = 'style1';
    this.subItemIcon = 'style1';

    this.displayBoxLayout = 'd-none';
    this.isVerticalLayoutChecked = false;
    this.isSidebarChecked = true;
    this.isHeaderChecked = true;
    this.headerFixedMargin = '50px'; // 50px
    this.sidebarFixedHeight = 'calc(100vh - 10px)'; // calc(100vh - 190px)
    this.itemBorderStyle = 'solid';
    this.subItemBorder = true;
    this.itemBorder = true;

    this.isCollapsedSideBar = 'no-block';

    this.perfectDisable = '';

    this.windowWidth = window.innerWidth;

    this.setMenuAttributes(this.windowWidth);
    this.setHeaderAttributes(this.windowWidth);

    // dark theme
    /*this.setLayoutType('dark');*/

    // light-dark
    /*this.setLayoutType('dark');
    this.setNavBarTheme('themelight1');*/

    // dark-light theme
    /*this.setNavBarTheme('theme1');*/

    // box layout
    /*this.setHeaderPosition();
    this.setSidebarPosition();
    this.setVerticalLayout();*/
  }

  ngOnInit() {
    this.getVehicleTypes();
    this.getChatUsers();
  }

  doInit() {
    const me = this;

    me.username = me.authService.getUserName();
    me.username = me.username?me.username:"[No Name]";
    //me.profilePicURL = me.authService.getProfilePicURL();
    //me.logoURL = me.authService.getLogoURL();
    
    me.authService.currentProfilePic.subscribe(profilePic => this.profilePicURL = profilePic);
    me.getProfilePicture();
    
    me.authService.currentCompanyLogo.subscribe(logo => this.logoURL = logo);
    me.getCompanyLogo();

    me.setBackgroundPattern('theme1');

    navigator.mediaDevices.getUserMedia(me.streamConstraints).then(function (stream) {
      me.addLocalStream(stream);

      me.mediaRecorder = new MediaRecorder(stream);

      me.mediaRecorder.addEventListener("dataavailable", event => {
        if(me.recording) {
          me.audioChunks.push(event.data);
        }
      });

      me.mediaRecorder.addEventListener("stop", () => {
        if(me.recording) {
          const audioBlob = new Blob(me.audioChunks, { 'type' : 'audio/ogg; codecs=opus' });
          if(me.actionBtn == "Send"){
            me.actionBtn = "";
            me.sendMessage(audioBlob, "voice");
          }
          me.recording = false;
          me.audioChunks = [];
        }
      });
    }).catch(function (err) {
      console.log(err, 'An error ocurred when accessing media devices');
    });

    me.socketService.userCallYou().subscribe(data => {
      me.onUserCallYou(data);
    });

    me.socketService.userAnswerCall().subscribe(data => {
      me.onUserAnswerCall(data);
    });

    me.socketService.onOffer().subscribe(data => {
      me.onOffer(data);
    });

    me.socketService.onAnswer().subscribe(data => {
      me.onAnswer(data);
    });

    me.socketService.onCandidate().subscribe(data => {
      me.onCandidate(data);
    });

    me.socketService.onHangUp().subscribe(data => {
      me.hangup();
    });

    me.socketService.callUser.subscribe((id) => {
      me.onYouCallUser(id);
    });

    me.socketService.onMessage().subscribe(data => {
      me.onMessage(data);
    });

    me.socketService.onNotification().subscribe(data =>{})

    me.socketService.onGetNotification().subscribe((data) =>{
      this.notifications = data.data;
      this.checkNewNotifications()
    })

    me.socketService.onRecieveNotification().subscribe((data) =>{
      console.log("Message >> ",data)
      this.notifications.unshift(data);
      if(data["isRead"] == false){
       this.newNotificationCount +=1;
      }
    })


    this.checkNewNotifications();
  }

  getProfilePicture() {
    this.authService.getProfilePicture().subscribe(result => {},error => {});
  }

  getCompanyLogo() {
    this.authService.getCompanyLogo().subscribe(result => {
      console.log("Result >>>>>>>>>>>>", result)
    },error => {
      console.log("ERROR >>>>>>>>>>>>", error)
    });
  }

  onLogout(){
      this.authService.logout();
      return false;
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    let reSizeFlag = true;
    if (this.pcodedDeviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 992) {
      reSizeFlag = false;
    } else if (this.pcodedDeviceType === 'phone' && this.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth <= 992) {
      this.navRight = 'nav-off';
    } else {
      this.navRight = 'nav-on';
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 992) {
      this.pcodedDeviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
      this.toggleIcon = 'icon-toggle-left';
      this.headerFixedTop = '50px';
    } else if (windowWidth < 768) {
      this.pcodedDeviceType = 'phone';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
      this.toggleIcon = 'icon-toggle-left';
      this.headerFixedTop = '50px';
    } else {
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
      this.toggleIcon = 'icon-toggle-right';
    }

    /*else if (windowWidth >= 1024 && windowWidth < 1366) {
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'collapsed';
      this.verticalEffect = 'shrink';
      this.toggleIcon = 'icon-toggle-left';
      this.perfectDisable = 'disabled';
      this.sidebarFixedHeight = '100%';
    }*/
  }

  toggleHeaderNavRight() {
    this.navRight = this.navRight === 'nav-on' ? 'nav-off' : 'nav-on';
    this.chatTopPosition = this.chatTopPosition === 'nav-on' ? '112px' : '';
    if (this.navRight === 'nav-off' && this.innerChatSlideInOut === 'in') {
      this.toggleInnerChat();
    }
    if (this.navRight === 'nav-off' && this.chatSlideInOut === 'in') {
      this.toggleChat();
    }
  }

  toggleLiveNotification() {
    if (this.profileNotification === 'an-animate') {
      this.toggleProfileNotification();
    }

    this.liveNotification = this.liveNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.liveNotificationClass = this.liveNotification === 'an-animate' ? 'show' : '';

    if (this.liveNotification === 'an-animate' && this.innerChatSlideInOut === 'in') {
      this.toggleInnerChat();
    }
    if (this.liveNotification === 'an-animate' && this.chatSlideInOut === 'in') {
      this.toggleChat();
    }
  }

  toggleProfileNotification() {
    if (this.liveNotification === 'an-animate') {
      this.toggleLiveNotification();
    }

    this.profileNotification = this.profileNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.profileNotificationClass = this.profileNotification === 'an-animate' ? 'show' : '';

    if (this.profileNotification === 'an-animate' && this.innerChatSlideInOut === 'in') {
      this.toggleInnerChat();
    }
    if (this.profileNotification === 'an-animate' && this.chatSlideInOut === 'in') {
      this.toggleChat();
    }
  }

  notificationOutsideClick(ele: string) {
    if (ele === 'live' && this.liveNotification === 'an-animate') {
      this.toggleLiveNotification();
    } else if (ele === 'profile' && this.profileNotification === 'an-animate') {
      this.toggleProfileNotification();
    }
  }

  toggleChat() {
    if (this.innerChatSlideInOut === 'in') {
      this.innerChatSlideInOut = 'out';
    } else {
      this.chatSlideInOut = this.chatSlideInOut === 'out' ? 'in' : 'out';
    }
  }

  toggleInnerChat(user?: any) {
    if(this.recording) return false;
    this.innerChatSlideInOut = this.innerChatSlideInOut === 'out' ? 'in' : 'out';
    this.selectedChatUser = user;
    if(user) this.getConversations(user.id);
  }

  searchOn() {
    document.querySelector('#main-search').classList.add('open');
    this.searchInterval = setInterval(() => {
      if (this.searchWidth >= 200) {
        clearInterval(this.searchInterval);
        return false;
      }
      this.searchWidth = this.searchWidth + 15;
      this.searchWidthString = this.searchWidth + 'px';
    }, 35);
  }

  searchOff() {
    this.searchInterval = setInterval(() => {
      if (this.searchWidth <= 0) {
        document.querySelector('#main-search').classList.remove('open');
        clearInterval(this.searchInterval);
        return false;
      }
      this.searchWidth = this.searchWidth - 15;
      this.searchWidthString = this.searchWidth + 'px';
    }, 35);
  }

  ngOnDestroy() {
    this.socketService.disconnect();
    if (this.searchInterval) {
      clearInterval(this.searchInterval);
    }
  }

  toggleOpened(e) {
    if (this.windowWidth <= 992) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      if (this.navRight === 'nav-on') {
        this.toggleHeaderNavRight();
      }
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
    }
    this.toggleIcon = this.verticalNavType === 'expanded' ? 'icon-toggle-right' : 'icon-toggle-left';
    this.animateSidebar = 'pcoded-toggle-animate';

    if (this.verticalNavType === 'collapsed') {
      this.perfectDisable = 'disabled';
      this.sidebarFixedHeight = '100%';
    } else {
      this.perfectDisable = '';
    }

    if (this.verticalNavType === 'collapsed' && this.isHeaderChecked === false) {
      this.setSidebarPosition();
    }

    setTimeout(() => {
      this.animateSidebar = '';
    }, 500);
  }

  onClickedOutsideSidebar(e: Event) {
    if ((this.windowWidth <= 992 && this.toggleOn && this.verticalNavType !== 'offcanvas') || this.verticalEffect === 'overlay') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
      this.toggleIcon = 'icon-toggle-left';
    }
  }

  toggleRightbar() {
    this.configOpenRightBar = this.configOpenRightBar === 'open' ? '' : 'open';
  }

  setNavBarTheme(theme: string) {
    if (theme === 'themelight1') {
      this.navBarTheme = 'themelight1';
      this.menuTitleTheme = 'theme1';
      this.sidebarImg = 'false';
    } else {
      this.menuTitleTheme = 'theme9';
      this.navBarTheme = 'theme1';
      this.sidebarImg = 'false';
    }
  }

  setLayoutType(type: string) {
    if (type === 'dark') {
      this.headerTheme = 'theme1';
      this.navBarTheme = 'theme1';
      this.activeItemTheme = 'theme1';
      this.freamType = 'theme1';
      document.querySelector('body').classList.add('dark');
      this.setBackgroundPattern('theme1');
      this.menuTitleTheme = 'theme9';
      this.layoutType = type;
      this.sidebarImg = 'false';
    } else if (type === 'light') {
      this.headerTheme = 'theme1';
      this.navBarTheme = 'themelight1';
      this.menuTitleTheme = 'theme1';
      this.activeItemTheme = 'theme1';
      this.freamType = 'theme1';
      document.querySelector('body').classList.remove('dark');
      this.setBackgroundPattern('theme1');
      this.layoutType = type;
      this.sidebarImg = 'false';
    } else if (type === 'img') {
      this.sidebarImg = 'true';
      this.navBarTheme = 'themelight1';
      this.menuTitleTheme = 'theme1';
      this.freamType = 'theme1';
      document.querySelector('body').classList.remove('dark');
      this.setBackgroundPattern('theme1');
      this.activeItemTheme = 'theme1';
    }
  }

  setVerticalLayout() {
    this.isVerticalLayoutChecked = !this.isVerticalLayoutChecked;
    if (this.isVerticalLayoutChecked) {
      this.verticalLayout = 'box';
      this.displayBoxLayout = '';
      this.pcodedHeaderPosition = 'relative';
      this.pcodedSidebarPosition = 'absolute';
      this.headerFixedMargin = '';
    } else {
      this.verticalLayout = 'wide';
      this.displayBoxLayout = 'd-none';
      this.pcodedHeaderPosition = 'fixed';
      this.pcodedSidebarPosition = 'fixed';
      this.headerFixedMargin = '50px';
    }
  }

  setBackgroundPattern(pattern: string) {
    document.querySelector('body').setAttribute('themebg-pattern', pattern);
    // this.menuTitleTheme = this.freamType = this.activeItemTheme = this.headerTheme = pattern;
  }

  setSidebarPosition() {
    if (this.verticalNavType !== 'collapsed') {
      this.isSidebarChecked = !this.isSidebarChecked;
      this.pcodedSidebarPosition = this.isSidebarChecked === true ? 'fixed' : 'absolute';
      this.sidebarFixedHeight = this.isSidebarChecked === true ? 'calc(100vh - 50px)' : '100%';
      if (this.isHeaderChecked === false) {
        window.addEventListener('scroll', this.scroll, true);
        window.scrollTo(0, 0);
      }
    }
  }

  setHeaderPosition() {
      this.isHeaderChecked = !this.isHeaderChecked;
      this.pcodedHeaderPosition = this.isHeaderChecked === true ? 'fixed' : 'relative';
      this.headerFixedMargin = this.isHeaderChecked === true ? '50px' : '';
      if (this.isHeaderChecked === false) {
        window.addEventListener('scroll', this.scroll, true);
        window.scrollTo(0, 0);
      } else {
        window.removeEventListener('scroll', this.scroll, true);
        if (this.pcodedDeviceType === 'desktop') {
          this.headerFixedTop = 'auto';
        }
        this.pcodedSidebarPosition = 'fixed';
        if (this.verticalNavType !== 'collapsed') {
          this.sidebarFixedHeight = this.isSidebarChecked === true ? 'calc(100vh - 50px)' : 'calc(100vh + 50px)';
        }
      }
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
    if (this.verticalNavType !== 'collapsed') {
      this.sidebarFixedHeight = this.isCollapsedSideBar === 'yes-block' ? 'calc(100vh - 50px)' : 'calc(100vh - 50px)';
    }
  }

  hoverOutsideSidebar() {
    if (this.verticalNavType === 'collapsed') {
      const mainEle = document.querySelectorAll('.pcoded-trigger');
      for (let i = 0; i < mainEle.length; i++) {
        mainEle[i].classList.remove('pcoded-trigger');
      }
    }
  }

  fireClick(e) {
    if (this.verticalNavType === 'collapsed') {
      const parentEle = e.target.parentNode.parentNode;
      if (parentEle.classList.contains('pcoded-trigger')) {
        const subEle = parentEle.querySelectorAll('.pcoded-hasmenu');
        for (let i = 0; i < subEle.length; i++) {
          if (subEle[i].classList.contains('pcoded-trigger')) {
            subEle[i].classList.remove('pcoded-trigger');
          }
        }
      } else {
        e.target.click();
      }
    }
  }

  fireClickLeave(e) {
    if (this.verticalNavType === 'collapsed') {
      const parentEle = <HTMLElement>e.target.parentNode.parentNode;
      const subEle = parentEle.querySelectorAll('.pcoded-hasmenu');
      for (let i = 0; i < subEle.length; i++) {
        if (subEle[i].classList.contains('pcoded-trigger')) {
          subEle[i].classList.remove('pcoded-trigger');
        }
      }
    }
  }

  //for video chat
  ngAfterViewInit() {
    var me = this;
    me.localAudio = document.getElementById("localAudio");
    me.remoteAudio = document.getElementById("remoteAudio");
    me.remoteAudio.ontimeupdate = function() {
      me.remoteAudioTime = me.formatTime(me.remoteAudio.currentTime);
    };
    //me.getVehicleTypes();
  }

  formatTime(s){
    var sec_num = parseInt(s, 10);
    var hours:any   = Math.floor(sec_num / 3600);
    var minutes:any = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds:any = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    return (hours!='00'?hours+':':'')+minutes+':'+seconds;
  }

  addLocalStream(stream) {
      this.localStream = stream;
      //localAudio.src = URL.createObjectURL(stream);
  }

  onYouCallUser(id) {
    var me = this, data = Globals["onlineUsers"][id];
    if(me.onCall){
      //already on call
      return;
    }
    if(data){
      me.socketService.youCallUser({id:data.id});
      me.onCall = true;
      me.callUserName = data.name;
      me.callUserId = data.id;
      me.callStatus = "Dialing";
      me.startCallTimer()
    } else {
      //user not online
    }
  }

  startCallTimer() {
    var me = this;
    me.stopCallTimer();
    me.callTimer = Observable.interval(10000).subscribe(() => {
      me.onHangUp(true);
      me.stopCallTimer();
    });
  }

  stopCallTimer() {
    if(this.callTimer) {
      this.callTimer.unsubscribe();
    }
  }

  onUserCallYou(data) {
    var me  = this;
    if(me.onCall) {
      me.socketService.youAnswerCall({id:data.id, accepted:false, busy:true});
      return;
    }
    me.onCall = true;
    me.callUserName = data.name;
    me.callUserId = data.id;
    me.callStatus = "Calling";
    me.startCallTimer();
  }

  onAnswerCall(accepted) {
    this.stopCallTimer();
    this.socketService.youAnswerCall({id:this.callUserId, accepted:accepted});
    if(accepted) {
      this.callStatus = "On Call";
    } else {
      this.hangup();
    }
  }

  onUserAnswerCall(data) {
    var me = this;
    me.stopCallTimer();
    if(data.accepted){
      me.connectedUser = data.id;
      this.callStatus = "On Call";
      me.createPeerConnection();
      let offerOptions = {
        offerToReceiveAudio: 1
      }
      me.rtcPeerConnection.createOffer(offerOptions)
          .then(desc => me.setLocalAndOffer(desc))
          .catch(e => console.log(e));
    } else {
      me.hangup();
    }
  }

  onOffer(data) {
    var me = this;
    me.connectedUser = data.id;
    me.createPeerConnection();
    me.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription(data.offer.sdp));
    me.rtcPeerConnection.createAnswer()
        .then(desc => me.setLocalAndAnswer(desc))
        .catch(e => console.log(e));
  }

  onAnswer(data) {
    this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription(data.answer.sdp));
  }

  onCandidate(data) {
    var candidate = new RTCIceCandidate({
        sdpMLineIndex: data.candidate.label,
        candidate: data.candidate.candidate
    });
    this.rtcPeerConnection.addIceCandidate(candidate);
  }

  onHangUp(timeout){
      this.socketService.hangup({id:this.connectedUser || this.callUserId, calltimeout:timeout});
      this.hangup();
  }

  setLocalAndOffer(sessionDescription) {
      this.rtcPeerConnection.setLocalDescription(sessionDescription);
      this.socketService.sendOffer({id:this.connectedUser, offer:{
          type: 'offer',
          sdp: sessionDescription
        }
      });
  }

  setLocalAndAnswer(sessionDescription) {
      this.rtcPeerConnection.setLocalDescription(sessionDescription);
      this.socketService.sendAnswer({id:this.connectedUser, answer:{
          type: 'answer',
          sdp: sessionDescription
        }
      });
  }

  hangup(){
    this.stopCallTimer();
    this.onCall = false;
    this.callUserName = "";
    this.callUserId = "";
    this.callStatus = "";
    this.connectedUser = null;
    this.remoteAudio.src = "";
    if(this.rtcPeerConnection){
       this.rtcPeerConnection.close();
       this.rtcPeerConnection.onicecandidate = null;
       this.rtcPeerConnection.onaddstream = null;
    }
  }

  createPeerConnection() {
      var me = this;
      me.rtcPeerConnection = new RTCPeerConnection(me.iceServers);
      me.rtcPeerConnection.onicecandidate = function(e){
        me.onIceCandidate(e);
      };
      me.rtcPeerConnection.onaddstream = function(e){
        me.onAddStream(e);
      };
      me.rtcPeerConnection.addStream(me.localStream);
      me.rtcPeerConnection.oniceconnectionstatechange = function(event) {
        console.log(me.rtcPeerConnection.iceConnectionState, event);
      };
  }

  onIceCandidate(event) {
      if (event.candidate) {
          this.socketService.sendCandidate({id: this.connectedUser, candidate:{
              type: 'candidate',
              label: event.candidate.sdpMLineIndex,
              id: event.candidate.sdpMid,
              candidate: event.candidate.candidate
            }
          });
      }
  }

  onAddStream(event) {
      this.remoteAudio.src = URL.createObjectURL(event.stream);
      this.remoteStream = event.stream;
      if (this.remoteStream.getAudioTracks().length > 0) {
          console.log('Remote user is sending Audio');
      } else {
          console.log('Remote user is not sending Audio');
      }
  }

  onActivate(event) {
	  window.scroll(0,0);
    if (!this.authService.isAuthenticated()) {
      this.router.navigateByUrl('/login');
    }
  }

  getChatUsers() {
    this.authService.getChatUsers().subscribe(
      data => {
        this.chatUsers = data;
      },
      err => {
        console.error(err);
        this.chatUsers = [];
      }
    );
  }

  getConversations(id) {
    this.chatLoading = true;
    this.conversations = [];
    this.authService.getConversations(id).subscribe(
      data => {
        this.conversations = data;
      },
      err => {
        console.error(err);
        this.conversations = [];
      },
      () => {
        this.chatLoading = false;
      }
    );
  }

  isLoggedInUser(id){
    return this.authService.isLoggedInUser(id);
  }

  onMessage(data){
    const me = this;
    const id = me.selectedChatUser?me.selectedChatUser.id:null;
    if(data && id && (id == data.from.id || id == data.to.id)) {
      me.conversations.push(data);
    }
  }

  sendMessage(content, type){
    const me = this;
    if(type == 'text') content = me.chatMessage;
    if(me.selectedChatUser){
      me.socketService.sendMessage(me.selectedChatUser.id, content, type, function(data) {
        if(data) {
          me.conversations.push(data);
        }
        if(type == 'text') me.chatMessage = '';
      });
    }
  }

  getVoiceMessage(id){
    const audioEl = document.getElementById("audio_"+id);
    if(audioEl){
      var status = audioEl.getAttribute('data-status');
      if(!status){
          console.log("downloading...");
          audioEl.setAttribute('data-status', 'downloading');
          this.socketService.getVoiceMessage(id, function(data){
            const audioUrl = URL.createObjectURL(data);
            if(audioEl){
              audioEl["src"] = audioUrl;
            }
          });
      }
    }
    return "";
  }

  startRecording(){
    this.actionBtn = 'Record';
    this.audioChunks = [];
    if(this.mediaRecorder){
      this.mediaRecorder.start();
      this.recording = true;
    }
  }

  stopRecording(action){
    this.actionBtn = action;
    if(this.mediaRecorder){
      this.mediaRecorder.stop();
    }
  }

  getVehicleTypes() {
    this.authService.getVehicleTypes().subscribe(
      data => {
        this.menuItems.setAssets(data);
        //console.log("Asset Types ", data);
      },
      err => {
        console.error(err);
      },
      () => {
        this.doInit();
        this.isReady = true;
      }
    );
  }

  showMenuItem(allowed_roles){
    return allowed_roles.indexOf("*") > -1 || allowed_roles.indexOf(this.authService.getUserRole()) > -1;
  }

  timeSince(newDate: Date | string):string {
    if(!newDate) return "...";

    let date:Date = null;

    if(typeof(newDate)=="string"){
      date = new Date(newDate);
    }
    else
    {
      date = new Date(newDate);
    }

    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
  
    var interval = Math.floor(seconds / 31536000);
  
    if (interval > 1) {
      return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

  checkNewNotifications():void{
    let count = 0;
    this.notifications.forEach((notification:NotificationI)=>{
      if(notification.isRead == false){
        count +=1;
      }
    });

    this.newNotificationCount = count;
  }

  readNotification(notification:NotificationI):void{
    if(notification.isRead == true) return;
    this.socketService.onReadNotification(notification);
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/admin/admin.component.ts